
export const parseDate = (phpDate: any): Date => {
  const unixTimestamp: number = (phpDate.timestamp as number)
  return new Date(unixTimestamp * 1000)
}
export const unixTimestamp = (): number => {
  const dateTime = Date.now();
  const timestamp = Math.floor(dateTime / 1000);
  return timestamp
}